import { defineMessages } from 'react-intl';

export default defineMessages({
    quickUploadSuccessMessage: {
        id: 'quick-upload.containers.quickUploadSuccessMessage',
        defaultMessage: 'You have successfully uploaded '
    },
    row: {
        id: 'quick-upload.containers.row',
        defaultMessage: 'Row'
    },
    record: {
        id: 'quick-upload.containers.record',
        defaultMessage: 'record'
    },
    success: {
        id: 'quick-upload.containers.success',
        defaultMessage: 'Success!'
    },
    errorMessageBody: {
        id: 'quick-upload.containers.errorMessageBody',
        defaultMessage: 'Please try uploading your file again.'
    },
    errorMessageHeader: {
        id: 'quick-upload.containers.errorMessageHeader',
        defaultMessage: 'Oops, something went wrong'
    },
    validationMessage: {
        id: 'quick-upload.containers.validationMessage',
        defaultMessage: 'Oops, there are errors in your file'
    },
    fileFormatValidationMessage: {
        id: 'quick-upload.containers.fileFormatValidationMessage',
        defaultMessage: 'Incorrect file format'
    },
    newStudentCM: {
        id: 'quick-upload.containers.newStudent',
        defaultMessage: 'New student'
    },
    updatedStudentCM: {
        id: 'quick-upload.containers.updatedStudent',
        defaultMessage: 'Updated student'
    },
    unassignedStudentCM: {
        id: 'quick-upload.containers.unassignedStudent',
        defaultMessage: 'Unassigned student'
    },
    newTeacherCM: {
        id: 'quick-upload.containers.newTeacher',
        defaultMessage: 'New teacher'
    },
    updatedTeacherCM: {
        id: 'quick-upload.containers.upatedTeacher',
        defaultMessage: 'Updated teacher'
    },
    newClassesCM: {
        id: 'quick-upload.containers.newClasses',
        defaultMessage: 'New classes'
    },
    updatedClassesCM: {
        id: 'quick-upload.containers.updatedClasses',
        defaultMessage: 'Updated classes'
    }
});



// WEBPACK FOOTER //
// ./app/containers/quick-upload/messages.js